// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__bizGT","productName":"Table_productName__2D4fn"};